//import react from 'react';
import './HeaderHostsignup.css';
import BreadcrumbCustom from '../BreadcrumbCustom/BreadcrumbCustom';
import { Link } from 'react-router-dom';

const HeaderHostsignup = () => {
    return(
        <>
        <header className="headerSignup">
            <div className="container">
                <div className="headerSignupInner">
                    <div className="logoSignup">
                        <Link to="/"><img width="40px" height="40px" src="/img/logo_small_r.svg" alt="Rentid logo"/></Link>
                    </div>
                    <BreadcrumbCustom/>
                </div>
            </div>
         </header>
        </>
    )
}

export default HeaderHostsignup;